import React from "react";
import { Outlet } from "react-router-dom";
import { stratosBackgroundColor } from "src/constants/colors";
import Header from "src/components/Header/Header";
import Footer from "src/components/Footer";
import { Box } from "@mui/material";
import GreenEllipse from "src/assets/images/layout/green.svg";
import PurpleEllipse from "src/assets/images/layout/purple.svg";
import styled from "styled-components";
import { Helmet } from "react-helmet";

import {
  footerHeight,
  headerHeight,
  inclusiveHeaderHeight,
  contentHeightWithoutHeaderAndFooter,
} from "src/constants/theme";

export interface IAppLayout {
  className?: string;
  children?: React.ReactNode;
}

const StyledBox = styled.div`
  overflow-x: clip;
  position: relative;
`;

// between the header and the footer
const MainContentContainer = styled.div`
  height: 100%;
  min-height: calc(100vh - ${contentHeightWithoutHeaderAndFooter});
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${GreenEllipse}), url(${PurpleEllipse});
  background-repeat: repeat-y, repeat-y;
  background-position:
    bottom 20% right -60vh,
    top 40px left -50vh;
`;

const MainContainer = styled.div`
  width: 90%;
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const AppCleanLayoutWithBg: React.FC<IAppLayout> = ({
  children,
  className,
  ...props
}) => {
  return (
    <>
      <Helmet
        titleTemplate="Stratos Blog - %s"
        defaultTitle="Stratos | The Next Generation of Decentralized Data Mesh"
        onChangeClientState={(newState, addedTags, removedTags) =>
          console.log("Helmet changed", newState, addedTags, removedTags)
        }
      >
        <title>Home Page</title>
        <meta
          name="description"
          content="Stratos is the infrastructure for decentralized services, which provides the blockchain applications with decentralized storage, decentralized database, and decentralized computing services"
        ></meta>

        <meta property="og:url" content="https://blog.thestratos.org/"></meta>

        <meta property="og:type" content="website"></meta>

        <meta
          property="og:title"
          content="Stratos | The Next Generation of Decentralized Data Mesh"
        ></meta>

        <meta
          property="og:description"
          content="Stratos is the infrastructure for decentralized services, which provides the blockchain applications with decentralized storage, decentralized database, and decentralized computing services"
        ></meta>

        <meta
          property="og:image"
          content="https://download.thestratos.org/stratos-website/img/preview/og_image_web3.png"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>

        <meta property="twitter:domain" content="blog.thestratos.org"></meta>

        <meta
          property="twitter:url"
          content="https://blog.thestratos.org/"
        ></meta>

        <meta
          name="twitter:title"
          content="! Stratos | The Next Generation of Decentralized Data Mesh"
        ></meta>

        <meta
          name="twitter:description"
          content="! Stratos is the infrastructure for decentralized services, which provides the blockchain applications with decentralized storage, decentralized database, and decentralized computing services"
        ></meta>

        <meta
          name="twitter:image"
          content="https://download.thestratos.org/stratos-website/img/preview/og_image_web3.png"
        ></meta>
      </Helmet>
      <StyledBox className="app_layout_box" {...props}>
        <Header
          className="app_header"
          sx={{
            height: `${headerHeight}`,
            position: "fixed",
            width: "100%",
            zIndex: "5",
          }}
        />
        <Box
          className="app_header_inclusive_box"
          sx={{
            height: inclusiveHeaderHeight,
          }}
        />

        <MainContentContainer className="main_content_container">
          <MainContainer className="main_container">
            {/* <SearchForm /> */}
            <Outlet />
          </MainContainer>
        </MainContentContainer>

        <Footer
          backgroundColor={stratosBackgroundColor}
          footerHeight={footerHeight}
        />
      </StyledBox>
    </>
  );
};

export default AppCleanLayoutWithBg;
